const Home = {
  setFullbannerSwiper: function () {      
    const fullbannerSlider = document.querySelectorAll('[data-swiper-fullbanner]');

    if (fullbannerSlider.length > 0) {
      fullbannerSlider.forEach(fullbanner => {  
        const pagination = fullbanner.querySelector('.swiper-pagination');

        const fullbannerSwiper = new Swiper(fullbanner, {
          watchOverflow: true,
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 4000,
          autoplay: {
            delay: 5000
          },
          pagination: {
            el: pagination,
            type: 'bullets',
            clickable: true,
            bulletClass: 'pagination-bullet',
            bulletActiveClass: 'active',
            renderBullet: function(index, className) {
              return `<button type="button" class="${className}" data-slide-index="${index}"><span class="bullet"></span></button>`;
            },
          },
          //swiper lazy load
          preloadImages: false,
          watchVisibility: true,
          lazy: {
            loadPrevNext: true,
            Amount: 1,
            loadOnTransitionStart: true
          }
        });

        fullbannerSwiper.on('slideChangeTransitionEnd', () => {
          $('.slide-text.active').removeClass('active');
          $('.swiper-slide-active .slide-text').addClass('active');
        });
      });
    }
  },
  init: function () {      
    const _this = this;

    _this.setFullbannerSwiper();
  }
}

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});

